import React from 'react';
import StandardAIDetail from './StandardAIDetail';

// Custom template for Utilization & Billing - can be customized later
const UtilizationBillingDetail = ({ card }) => {
  // For now, use the standard template
  // You can customize this component with specific UI for Utilization & Billing
  return <StandardAIDetail card={card} />;
};

export default UtilizationBillingDetail;
